import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ts1 from '../../images/testimonial/img-1.jpg'
import ts2 from '../../images/testimonial/img-2.jpg'
import ts3 from '../../images/testimonial/img-3.jpg'


class Testimonial2 extends Component {
    render() {
        var settings = {
            dots: false,
            arrows: true,
            speed: 1000,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        const testimonial = [
            {
                tsImg: ts1,
                Des: "",
                Title: 'Enes Can Polat',
                Sub: "Executive Director",
            },
            {
                tsImg: ts2,
                Des: "",
                Title: 'Said Selmanlar',
                Sub: "President",
            },
            {
                tsImg: ts3,
                Des: "",
                Title: 'Ramazan Tekin',
                Sub: "Treasurer",
            },
            {
                tsImg: ts1,
                Des: "",
                Title: 'Omer Erturk',
                Sub: "Board Member",
            },
            {
                tsImg: ts1,
                Des: "",
                Title: 'Recep Dinc',
                Sub: "Board Member",
            },
            {
                tsImg: ts1,
                Des: "",
                Title: 'Fatih Gozuacik',
                Sub: "Board Member",
            },
        ]
        return (

            <div className={`wpo-testimonial-area-s2 section-padding ${this.props.tClass}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="wpo-section-title">
                                <h2>Mission</h2>
                                <p>Our mission is to empower youth by building strong moral values, social capital, academic success, and leadership capabilities. We aim to foster a culture of living in harmony and peace, and appreciation of diversity through volunteering experiences, mentoring, and educational programs. Additionally, we strive to help youth advance their social and professional skills to build successful careers.</p>
                            </div>
                            <div className="wpo-section-title">
                                <h2>Vision</h2>
                                <p>
                                Our vision is to empower youth by promoting moral values, social capital, academic success, and leadership. We aim to foster harmony, peace, and diversity through volunteering, mentoring, and educational programs. Additionally, we support non-profits by addressing human resources needs and offering career development, seminars, events, and networking. We strive to be a role model in creating human resources policies aligned with empowerment and inclusivity.</p>
                            </div>
                        </div>
                    </div>
                    <div className="wpo-testimonial-wrap">
                        <div className="testimonial-slider owl-carousel">
                        <Slider {...settings}>
                                {testimonial.map((tesmnl, tsm) => (
                                    <div className="wpo-testimonial-item" key={tsm}>
                                        <div className="wpo-testimonial-img">
                                            <img src={tesmnl.tsImg} alt="" />
                                        </div>
                                        <div className="wpo-testimonial-content">
                                            <p>{tesmnl.Des}</p>
                                            <h2>{tesmnl.Title}</h2>
                                            <span>{tesmnl.Sub}</span>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Testimonial2;